import React from 'react';
import { TableBodyProps } from './table-body-props';
import { cx } from '@mint/core';
import styled from 'styled-components';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'table-body';

/**
 * Component to use.
 */
const DEFAULT_COMPONENT = 'div';

/**
 * List component implementation before styling.
 */
export const TableBodyComponent = React.forwardRef<any, TableBodyProps>(
  (props, ref): React.ReactElement => {
    const {
      children,
      className,
      component: Component = DEFAULT_COMPONENT,
      ...rest
    } = props;

    const componentProps = {
      className: cx(ROOT_CLASS_NAME, className),
      ...rest,
      ref,
    };

    return <Component {...componentProps}>{children}</Component>;
  },
);

TableBodyComponent.displayName = 'TableBody';

export const TableBody = styled(TableBodyComponent)``;
